(function () {
  'use strict';

  var supportedHandles = [
    '4x2ft-pvc-banner',
    '10x4ft-pvc-banner',
    'frosted-vinyl-graphics',
    'digital-smooth-wallpaper',
    'digital-printed-vinyl',
    'digital-textured-wallpaper',
    'digital-self-adhesive-vinyl',
    'foamex-flat-panel-signage-kit',
    'contravision'
  ];
  var handleMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
  if (!handleMatch || supportedHandles.indexOf(handleMatch[1]) === -1) return;
  var currentHandle = handleMatch[1];
  var storageKey = 'pz-banner-size:' + currentHandle;

  var factorsToMetres = {
    mm: 0.001,
    cm: 0.01,
    m: 1,
    ft: 0.3048
  };
  var labels = { mm: 'mm', cm: 'cm', m: 'm', ft: 'ft' };
  var activeUnit = 'mm';
  var timer = null;
  var lastEntered = '';
  var lastConverted = '';
  var lastWidthMetres = null;
  var lastHeightMetres = null;
  var propertyRefreshQueued = false;

  try {
    var storedSize = JSON.parse(window.sessionStorage.getItem(storageKey));
    if (storedSize && factorsToMetres[storedSize.unit] && storedSize.widthMetres > 0 && storedSize.heightMetres > 0) {
      activeUnit = storedSize.unit;
      lastWidthMetres = storedSize.widthMetres;
      lastHeightMetres = storedSize.heightMetres;
    } else if (storedSize && factorsToMetres[storedSize.unit] && storedSize.widthFeet > 0 && storedSize.heightFeet > 0) {
      activeUnit = storedSize.unit;
      lastWidthMetres = storedSize.widthFeet * 0.3048;
      lastHeightMetres = storedSize.heightFeet * 0.3048;
    }
  } catch (error) {
    window.sessionStorage.removeItem(storageKey);
  }

  function formatNumber(value, precision) {
    if (!Number.isFinite(value)) return '';
    return String(Number(value.toFixed(precision)));
  }

  function readPositive(input) {
    var value = parseFloat(input.value);
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  function fire(input, includeChange) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('keyup', { bubbles: true }));
    if (includeChange) input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function ensureProperty(form, name) {
    var selector = 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var field = form.querySelector(selector);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      form.appendChild(field);
    }
    return field;
  }

  function updateOrderProperties(entered, converted) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.id === 'product-form-installment') return;
      var enteredField = ensureProperty(form, 'properties[Finished size entered]');
      var convertedField = ensureProperty(form, 'properties[Size used for pricing]');
      enteredField.value = entered;
      enteredField.defaultValue = entered;
      enteredField.setAttribute('value', entered);
      convertedField.value = converted;
      convertedField.defaultValue = converted;
      convertedField.setAttribute('value', converted);
    });
  }

  function queuePropertyRefresh() {
    if (propertyRefreshQueued) return;
    propertyRefreshQueued = true;
    window.requestAnimationFrame(function () {
      propertyRefreshQueued = false;
      updateOrderProperties(lastEntered, lastConverted);
    });
  }

  function convertMetresToUnit(value, unit) {
    return value / factorsToMetres[unit];
  }

  function setSummary(summary, width, height, widthMetres, heightMetres, nativeUnit) {
    lastEntered = formatNumber(width, 3) + ' × ' + formatNumber(height, 3) + labels[activeUnit];
    lastConverted = formatNumber(convertMetresToUnit(widthMetres, nativeUnit), 3) + ' × ' + formatNumber(convertMetresToUnit(heightMetres, nativeUnit), 3) + labels[nativeUnit];
    summary.textContent = activeUnit === nativeUnit
      ? 'Finished size: ' + lastEntered + '. Your price will calculate below.'
      : 'Finished size: ' + lastEntered + ' (' + lastConverted + '). Your price will calculate below.';
    updateOrderProperties(lastEntered, lastConverted);
  }

  function persistSize() {
    window.sessionStorage.setItem(storageKey, JSON.stringify({
      unit: activeUnit,
      widthMetres: lastWidthMetres,
      heightMetres: lastHeightMetres
    }));
  }

  function sync(nativeWidth, nativeHeight, nativeUnit, uiWidth, uiHeight, summary, includeChange) {
    var width = readPositive(uiWidth);
    var height = readPositive(uiHeight);
    if (width === null || height === null) {
      summary.textContent = '';
      lastEntered = '';
      lastConverted = '';
      lastWidthMetres = null;
      lastHeightMetres = null;
      window.sessionStorage.removeItem(storageKey);
      updateOrderProperties(lastEntered, lastConverted);
      return;
    }

    var widthMetres = width * factorsToMetres[activeUnit];
    var heightMetres = height * factorsToMetres[activeUnit];
    lastWidthMetres = widthMetres;
    lastHeightMetres = heightMetres;
    persistSize();
    nativeWidth.value = formatNumber(convertMetresToUnit(widthMetres, nativeUnit), 6);
    nativeHeight.value = formatNumber(convertMetresToUnit(heightMetres, nativeUnit), 6);

    fire(nativeWidth, includeChange);
    fire(nativeHeight, includeChange);

    setSummary(summary, width, height, widthMetres, heightMetres, nativeUnit);
  }

  function scheduleSync(nativeWidth, nativeHeight, nativeUnit, uiWidth, uiHeight, summary) {
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      sync(nativeWidth, nativeHeight, nativeUnit, uiWidth, uiHeight, summary, true);
    }, 350);
  }

  function convertDisplayedValues(uiWidth, uiHeight, fromUnit, toUnit) {
    [uiWidth, uiHeight].forEach(function (input) {
      var value = readPositive(input);
      if (value === null) return;
      var metres = value * factorsToMetres[fromUnit];
      input.value = formatNumber(metres / factorsToMetres[toUnit], toUnit === 'mm' ? 1 : 3);
    });
  }

  function createInterface(nativeField, nativeWidth, nativeHeight, nativeUnit) {
    var container = document.createElement('section');
    container.className = 'pz-banner-units';
    container.setAttribute('aria-labelledby', 'pz-banner-units-heading');
    container.innerHTML =
      '<h2 class="pz-banner-units__heading" id="pz-banner-units-heading">Enter your finished size</h2>' +
      '<p class="pz-banner-units__intro">Choose the unit you normally work in. We will convert it automatically for pricing.</p>' +
      '<fieldset class="pz-banner-units__fieldset">' +
        '<legend class="pz-banner-units__legend">Measurement unit</legend>' +
        '<div class="pz-banner-units__tabs" role="group" aria-label="Measurement unit">' +
          '<button type="button" class="pz-banner-units__tab" data-unit="mm" aria-pressed="true">mm</button>' +
          '<button type="button" class="pz-banner-units__tab" data-unit="cm" aria-pressed="false">cm</button>' +
          '<button type="button" class="pz-banner-units__tab" data-unit="m" aria-pressed="false">metres</button>' +
          '<button type="button" class="pz-banner-units__tab" data-unit="ft" aria-pressed="false">feet</button>' +
        '</div>' +
      '</fieldset>' +
      '<div class="pz-banner-units__fields">' +
        '<label><span class="pz-banner-units__label">Width</span><span class="pz-banner-units__input-wrap"><input class="pz-banner-units__input" data-dimension="width" type="number" min="0" step="any" inputmode="decimal" autocomplete="off" aria-describedby="pz-banner-units-summary"><span class="pz-banner-units__suffix">mm</span></span></label>' +
        '<label><span class="pz-banner-units__label">Height</span><span class="pz-banner-units__input-wrap"><input class="pz-banner-units__input" data-dimension="height" type="number" min="0" step="any" inputmode="decimal" autocomplete="off" aria-describedby="pz-banner-units-summary"><span class="pz-banner-units__suffix">mm</span></span></label>' +
      '</div>' +
      '<p class="pz-banner-units__summary" id="pz-banner-units-summary" aria-live="polite"></p>';

    nativeField.parentNode.insertBefore(container, nativeField);
    nativeField.classList.add('pz-banner-units__native');

    var uiWidth = container.querySelector('[data-dimension="width"]');
    var uiHeight = container.querySelector('[data-dimension="height"]');
    var summary = container.querySelector('.pz-banner-units__summary');
    var tabs = container.querySelectorAll('[data-unit]');

    if (lastWidthMetres !== null && lastHeightMetres !== null) {
      var restoredWidth = lastWidthMetres / factorsToMetres[activeUnit];
      var restoredHeight = lastHeightMetres / factorsToMetres[activeUnit];
      uiWidth.value = formatNumber(restoredWidth, activeUnit === 'mm' ? 1 : 3);
      uiHeight.value = formatNumber(restoredHeight, activeUnit === 'mm' ? 1 : 3);
      tabs.forEach(function (item) {
        item.setAttribute('aria-pressed', String(item.getAttribute('data-unit') === activeUnit));
      });
      container.querySelectorAll('.pz-banner-units__suffix').forEach(function (suffix) {
        suffix.textContent = labels[activeUnit];
      });
      setSummary(summary, restoredWidth, restoredHeight, lastWidthMetres, lastHeightMetres, nativeUnit);
    }

    [uiWidth, uiHeight].forEach(function (input) {
      input.addEventListener('input', function () {
        scheduleSync(nativeWidth, nativeHeight, nativeUnit, uiWidth, uiHeight, summary);
      });
      input.addEventListener('blur', function () {
        window.clearTimeout(timer);
        sync(nativeWidth, nativeHeight, nativeUnit, uiWidth, uiHeight, summary, true);
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var nextUnit = tab.getAttribute('data-unit');
        if (nextUnit === activeUnit) return;
        convertDisplayedValues(uiWidth, uiHeight, activeUnit, nextUnit);
        activeUnit = nextUnit;
        tabs.forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === tab));
        });
        container.querySelectorAll('.pz-banner-units__suffix').forEach(function (suffix) {
          suffix.textContent = labels[activeUnit];
        });
        sync(nativeWidth, nativeHeight, nativeUnit, uiWidth, uiHeight, summary, true);
      });
    });
  }

  function mount() {
    if (document.querySelector('.pz-banner-units')) return true;
    var lengthInput = document.querySelector('#eo-sh-length');
    var widthInput = document.querySelector('#eo-sh-width');
    if (!lengthInput || !widthInput) return false;
    var nativeField = lengthInput.closest('.eo-sh-measurement-field');
    if (!nativeField) return false;

    function labelFor(input) {
      var linked = input.id ? nativeField.querySelector('label[for="' + input.id + '"]') : null;
      if (linked) return linked.textContent.toLowerCase();
      var sibling = input.previousElementSibling;
      while (sibling) {
        if (sibling.tagName === 'LABEL') return sibling.textContent.toLowerCase();
        sibling = sibling.previousElementSibling;
      }
      return '';
    }

    var lengthLabel = labelFor(lengthInput);
    var widthLabel = labelFor(widthInput);
    var nativeWidth = lengthLabel.indexOf('width') !== -1 ? lengthInput : widthInput;
    var nativeHeight = lengthLabel.indexOf('height') !== -1 ? lengthInput : widthInput;
    var nativeUnit = (lengthLabel + ' ' + widthLabel).indexOf('mm') !== -1 ? 'mm' : 'ft';
    createInterface(nativeField, nativeWidth, nativeHeight, nativeUnit);
    return true;
  }

  function start() {
    mount();
    var mountObserver = new MutationObserver(function () {
      if (!document.querySelector('.pz-banner-units')) mount();
      if (document.querySelector('.pz-banner-units')) queuePropertyRefresh();
    });
    mountObserver.observe(document.documentElement, { childList: true, subtree: true });

    function prepareOrderDetails(event) {
      var form = event.target && event.target.closest ? event.target.closest('form[action*="/cart/add"]') : null;
      if (!form || form.id === 'product-form-installment') return;
      updateOrderProperties(lastEntered, lastConverted);
    }

    document.addEventListener('pointerdown', prepareOrderDetails, true);
    document.addEventListener('click', prepareOrderDetails, true);
    document.addEventListener('submit', prepareOrderDetails, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
